import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { playSound } from '../../../utils/audio-helper';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import './index.css';

const LandingScreen = props => {

	const { transitionOut, sounds } = props;
	let [homepageClassName, setHomepageClassName] = useState('');

	const handleAnimationEnd = evt => {
		const { animationName } = evt;
		// transitionOut();
	}

	useEffect(()=>{
		// playSound(sounds, 'intro_theme');
	}, []);

	return (
		<div className={'landing-page'} onAnimationEnd={handleAnimationEnd}>
			<div className="tagline">Can you win in a</div>
			<div className="show-logo" />
			<div className='clock-container'>
				<CountdownCircleTimer
					isPlaying
					duration={5}
					colors={'#CFAB53'}
					onComplete={()=>{
						transitionOut();
					}}
					size={90}
					strokeWidth={7}
					className={'clock'}
					trailColor={'#ffffff00'}
				>
					{({ remainingTime }) => remainingTime}
				</CountdownCircleTimer>
			</div>
			<div className="show-tunein"><gsntv-wc-tune-in show-id="split-second"></gsntv-wc-tune-in></div>
		</div>
	)
}

export default LandingScreen;